import { memo } from 'react'

import { OnlyFansMessageReleaseForm, TaggableUser } from '@api'

import { Checkbox } from '@/components/ui/checkbox'
import { unescapeHtmlText } from '@/modules/chatting/ui/chat-window/fan-info/utils'
import { CreatorAvatar } from '@/modules/creators/ui/CreatorAvatar'
import { isUserType } from '@/utils/releaseForms'

import { TaggableItemActions } from '../TaggableItemActions'

interface Props {
  isSelected?: boolean
  viewMessageTagsMode?: boolean
  style?: React.CSSProperties
  onChangeSelected?: (isSelected: boolean) => void
  taggable: TaggableUser | OnlyFansMessageReleaseForm
  onRemoveTag?: () => void
  onEditTag?: (id: number, name: string) => void
  onToggleShow?: () => void
}

export const TaggableCreatorsItem = memo(
  ({
    isSelected = false,
    onChangeSelected,
    style,
    taggable,
    onRemoveTag,
    onEditTag,
    onToggleShow,
  }: Props) => (
    <label
      htmlFor={String(taggable.id)}
      style={style}
      className="hover:bg-primary-50 dark:hover:bg-secondary-600 cursor-pointer"
    >
      <div className="flex h-[82px] w-full items-center justify-between p-4">
        <div className="flex items-center justify-between gap-3">
          {!!onChangeSelected && (
            <Checkbox
              id={String(taggable.id)}
              onCheckedChange={onChangeSelected}
              checked={isSelected}
            />
          )}
          <CreatorAvatar
            name={taggable.name || ''}
            avatarSrc={isUserType(taggable.type) ? taggable.user?.avatar : null}
            size={50}
            className="mr-2"
          />
          <div className="space-y-0.5">
            <p className="font-medium leading-[26px]">
              {unescapeHtmlText(taggable.name)}
            </p>
            <p className="text-secondary-300 text-sm leading-[22px]">
              {isUserType(taggable.type) ? 'Verified' : 'Guest'}
            </p>
          </div>
        </div>
        <TaggableItemActions
          taggable={taggable}
          onRemoveTag={onRemoveTag}
          onToggleShow={onToggleShow}
          onEditTag={onEditTag}
        />
      </div>
      <div className="ml-[78px] mr-4 border-b" />
    </label>
  ),
)

TaggableCreatorsItem.displayName = 'TaggableCreatorsItem'
